import React, { useCallback } from 'react';
import { MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { NonRecurrentHypothesisType } from './helpers/constants';

const StyHypothesisTypeSelect = styled(Select, {
    name: 'StyHypothesisTypeSelect',
})(({ theme }) => ({
    '& .MuiSelect-select': {
        backgroundColor: 'white',
        border: `1px solid ${theme.palette.primary.dark}`,
        color: theme.palette.primary.dark,
        fontSize: '12px',
        padding: '0.2rem 0.8rem',
        height: 'max-content',
        width: 'max-content',
    },

    '& .MuiOutlinedInput-notchedOutline': { border: 0 },
    '& svg.MuiSelect-icon': {
        color: theme.palette.primary.dark,
    },
    '& .MuiTypography-root': {
        fontSize: '0.9rem',
    },
}));

type Props = {
    currentType: NonRecurrentHypothesisType;
    onChange: (newType: NonRecurrentHypothesisType) => void;
};

export function HypothesisTypeSelector({ currentType, onChange }: Props) {
    const { t } = useTranslation();

    const handleChange = useCallback(
        (event: SelectChangeEvent<string>) => {
            const newType = event.target.value as NonRecurrentHypothesisType;
            onChange(newType);
        },
        [onChange],
    );

    return (
        <StyHypothesisTypeSelect
            value={currentType}
            onChange={handleChange}
            renderValue={(value: string) => (
                <Typography>
                    {t(
                        `humanResources.simulation.hyptothesisTypePerStatus.${value}`,
                    )}
                </Typography>
            )}
        >
            <MenuItem value={NonRecurrentHypothesisType.AGENT}>
                {t('humanResources.simulation.hyptothesisTypePerStatus.agent')}
            </MenuItem>
            <MenuItem value={NonRecurrentHypothesisType.ENVELOPE}>
                {t(
                    'humanResources.simulation.hyptothesisTypePerStatus.envelope',
                )}
            </MenuItem>
        </StyHypothesisTypeSelect>
    );
}
